import CustomModal from "../CustomModal";
import { translate } from "../../Services/translation";
import React, { useState } from "react";
import button from "../Button";

export default function OnDemandModal({ items, open, setOpen, logos, onClick, comment }) {
    const [logo, setLogo] = useState(null);
    const [message, setMessage] = useState("");
    const [logoComment, setLogoComment] = useState("");
    const [commentErrorMessage, setCommentErrorMessage] = useState("");

    async function handleOnClick() {
        setMessage("");
        setCommentErrorMessage("");

        if (!logo) {
            setMessage(translate('forms.logorequiredtext'));

            return;
        }

        if (logo.showComment && logoComment.length === 0) {
            setCommentErrorMessage(translate('forms.logocommentrequiredtext'));

            return;
        }

        if (logo.showComment && logoComment.length >= 100) {
            setCommentErrorMessage(translate('checkout.forms.errors.maxlength', 100));

            return;
        }


        let onDemandComment;

        if(logo.showComment){
            onDemandComment = {
                label: logo.commentLabel,
                comment: logoComment,
            }
        }

        onClick(logo, onDemandComment);

        setOpen(false);
    }

    return (
        <CustomModal isOpen={open} onClose={() => setOpen(false)}
                     title={translate('product.logo.title')}
                     description={translate('product.logo.description')}
        >
            <div>
                <div className="product-detail__logo-form-container">
                    <div className="product-detail__logo-input-container">
                        {
                            logos.map((x, index) => <button onClick={() => setLogo(x)}
                                                            className={"product-detail__logo-tag " + (logo?.name === x.name ? "product-detail__logo-tag--selected" : " ")}
                                                            key={index}>{x.name}</button>)
                        }
                    </div>
                    {
                        message && <p className="modal__error-message">{message}</p>
                    }
                </div>

                {
                    logo?.showComment && <div className="product-detail__logo-comment-container">
                        <label className="product-detail__logo-comment-label" htmlFor="">{logo?.commentLabel}</label>


                        <p>{logo?.commentDescription}</p>

                        <textarea className="product-detail__logo-comment-textarea"
                                  onChange={(e) => setLogoComment(e.target.value)}
                                  placeholder={logo?.commentPlaceholder} cols="30"
                                  rows="4"></textarea>

                        {
                            commentErrorMessage && <p className="modal__error-message">{commentErrorMessage}</p>
                        }
                    </div>

                }

                {
                    comment && <div className="modal__notice-container">
                        <p className="modal__notice-text">{comment}</p>
                    </div>
                }

                <button
                    className="modal__submit-button"
                    onClick={() => handleOnClick()}>{translate('product.logo.submit')}
                </button>
            </div>
        </CustomModal>
    )
}
